import actionTypes from '../actions/actionTypes';

const INITIAL_STATE = {
  capabilityToken: {},
};

export const voiceCall = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case actionTypes.DO_VOICE_CALL:
      return {
        ...state,
      };
    case actionTypes.DO_VOICE_CALL_SUCCESS:
      return {
        ...state,
        capabilityToken: payload,
      };
    case actionTypes.DO_VOICE_CALL_ERROR:
      return {
        ...state,
        error: payload,
      };

    default:
      return state;
  }
};

export default voiceCall;
